import React, { Fragment } from "react";
import Plot from "react-plotly.js";
import { useTheme } from "@mui/material";
import IncomeChart from "components/cards/income/IncomeChart.component";
import { useTranslation } from "react-i18next";

const HorizontalBarChartPlotly = ({
  data,
  titleChart,
  yLabel,
  xLabel,
  isLoading,
  xRange,
  height = 410,
}) => {
  const theme = useTheme();
  const { i18n } = useTranslation();

  return isLoading ? (
    <IncomeChart />
  ) : (
    <Fragment>
      <Plot
        config={{
          responsive: true,
          locale: i18n?.language ? i18n.language : "it",
        }}
        data={data}
        layout={{
          margin: {
            l: 125,
            r: 70,
            t: 8,
            pad: 2,
          },
          plot_bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.background.default
              : "white",
          paper_bgcolor:
            theme.palette.mode === "dark"
              ? theme.palette.background.default
              : "white",
          autosize: true,
          title: titleChart,
          titlefont: {
            size: 16,
            color:
              theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
          },
          xaxis: {
            title: xLabel,
            tickfont: {
              size: 11,
              color:
                theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
            },
            titlefont: {
              size: 12,
              color:
                theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
            },
            range: xRange,
          },
          yaxis: {
            title: yLabel,
            titlefont: {
              size: 11,
              color:
                theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
            },
            tickfont: {
              size: 10,
              color:
                theme.palette.mode === "dark" ? "white" : "rgb(107, 107, 107)",
            },
            dtick: 1
          },
          legend: {
            x: 0.7,
            y: 0.98,
            font: {
              size: 10,
              color: theme.palette.mode === "dark" ? "white" : "black",
            },
            bgcolor: "rgba(255, 255, 255, 0)",
            bordercolor: "rgba(255, 255, 255, 0)",
          },
          barmode: "group",
        }}
        style={{
          minHeight: height,
          width: "100%",
          height: "100%",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      />
    </Fragment>
  );
};

export default HorizontalBarChartPlotly;
